<p-dialog styleClass="notes" #notes [closable]="false" [(visible)]="displayActiveInactiveModal" [modal]="true"
    [style]="{width: '55%', minWidth: '55%'}" appendTo="body">
    <p-header>
        <h5 class="p-d-inline-block p-mb-0">
            {{commentHeaderName}}
        </h5>
    </p-header>

    <ng-container *ngIf="activeInactiveFormType == 'Add' ">
        <div class="p-grid">

            <div class="p-col-12" *ngIf="statusId == 1">
                <label class="p-mt-4">Inactivate Reason<span style="color: red;">*</span></label>
                <p-multiSelect
                        [options]="inActivatingReason"
                        [(ngModel)]="selectedInactiveReasons"
                        id="inActivatingReason"
                        placeholder="Choose Deactivate Reason"
                        (onChange)="onChangeActiveReason($event)"
                        optionLabel="name"
                        appendTo="body" >
                </p-multiSelect>
                <small class="p-invalid"
                    *ngIf="reasonsValidation">Reason is required
                </small>
            </div>

            <div class="p-col-12" *ngIf="statusId == 2">
                <label class="p-mt-4">Activate Reason<span style="color: red;">*</span></label>
                <p-multiSelect
                        [options]="activatingReason"
                        [(ngModel)]="selectedActiveReasons"
                        (onChange)="onChangeInactiveReason($event)"
                        id="activatingReason"
                        placeholder="Choose Activate Reason"
                        optionLabel="name"
                        appendTo="body" >
                </p-multiSelect>
                <small class="p-invalid"
                    *ngIf="reasonsValidation">Reason is required
                </small>
            </div>

            <div class="p-col-12 p-fluid p-mt-2">
                <label class="p-mt-4">Comments <span style="color: red;">*</span></label>
                <textarea rows="5" cols="100" [(ngModel)]="commentObject.comment" placeholder="Enter Comment"
                    pInputTextarea id="comment" name="comment" required>
                  </textarea>
                <small class="p-invalid" *ngIf="commentInvalid && commentObject.comment.trim()?.length==0">Comment is required</small>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="activeInactiveFormType == 'View' ">
        <div class="p-grid p-pt-3">
            <div class="p-col p-lg-12 p-md-12">
              <h6 class="p-mb-1">
                <span *ngIf="activeInactiveData?.type == 'ActiveInactiveContactLog' ">Contact </span>
                <span *ngIf="activeInactiveData?.type == 'ActiveInactiveOpportunityLog' ">Opportunity </span>
                <span *ngIf="activeInactiveData?.type == 'ActiveInactiveLeadLog' ">Lead </span>
                <span *ngIf="activeInactiveData?.type == 'ActiveInactiveAccountLog' ">Account </span>
                <span *ngIf="activeInactiveData?.objectData?.status?.id == 1">Activated</span>
                <span *ngIf="activeInactiveData?.objectData?.status?.id == 2">Inactivated</span>
                <span *ngIf="activeInactiveData?.objectData?.status?.id == 3">Deleted</span>
                by {{ activeInactiveData?.createdByUserName}}
                <span class="pull-right">
                  {{ activeInactiveData?.objectData.createdDate | localDate }}
                </span>
              </h6>
              <p class="p-col p-lg-12 p-md-12" style="margin-left: -6px;" [innerHTML]="activeInactiveData?.objectData?.comment">
              </p>

              <div *ngIf="reasonsList?.length > 0">
                  <h6> Reasons </h6>
                  <p *ngFor="let reason of reasonsList">
                       {{ reason.name }}
                  </p>
              </div>

            </div>
          </div>
    </ng-container>

    <ng-template pTemplate="footer">
        <button pButton label="Close" (click)="cancelComment()" class="p-button-secondary"></button>
        <button pButton label="Save" *ngIf="activeInactiveFormType == 'Add' " (click)="saveComment()"></button>
    </ng-template>
</p-dialog>
